import { render } from "./H5WechatGoldPage.vue?vue&type=template&id=19f0d8a5&scoped=true"
import script from "./H5WechatGoldPage.vue?vue&type=script&lang=js"
export * from "./H5WechatGoldPage.vue?vue&type=script&lang=js"

import "./H5WechatGoldPage.vue?vue&type=style&index=0&id=19f0d8a5&scoped=true&lang=css"

import exportComponent from "D:\\fxwl\\wx-wl_full\\wx-wl_full\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19f0d8a5"]])

export default __exports__